// extracted by mini-css-extract-plugin
module.exports = {"container":"gJ","links":"hJ"};